// extracted by mini-css-extract-plugin
export default {"buton":"AssociateAssetDialog_buton__L3Ww7"};